@if (iconClass) {
<i [ngClass]="iconClass"
  [style.color]="iconColor"
  [attr.data-testid]="'vi-link-icon-' + (text || href)"></i>
}
<a class="vi-link"
  [ngClass]="{'accessible': accessibilityMode, 'with-inline': inline, 'truncate': withTruncate}"
  [target]="role !== 'link' ? '' : target"
  [attr.role]="role"
  [attr.aria-label]="text"
  [attr.title]="text"
  [attr.tabindex]="0"
  [style]="linkColorStyle"
  (viUiAccessibleClick)="linkClicked.emit(href)"
  [attr.href]="href"
  [attr.data-testid]="'vi-link-' + (text || href)">
  <vi-ui-text [inline]="inline"
    [size]="size"
    [text]="text"
    color="'currentColor'"
    [attr.data-testid]="'vi-link-text-' + (text || href)">
  </vi-ui-text>
</a>
